import React, { useState, useEffect } from "react";
import tick from "../../../assets/icons/tick.svg";
import axios from "axios";
import { ThreeDots } from "react-loader-spinner";
import { useUserContext } from "../../../context/MemorialContext";
import "./ChoosePlane.css";
import { useNavigate } from "react-router-dom";
import { US_STATES, EXCLUDED_SHIPPING_STATES } from "../../../utils/usStates";
import usFlag from "../../../assets/us-flag.webp";

const Plan = () => {
  const navigate = useNavigate();
  const Plans = [
    {
      planName: 0,
      //priceId: "price_1PR5VMLZaqlFZMo5EtzoSkud",
      priceId: "price_1PhrBOLZaqlFZMo5blqAlrfs",
      testId: "price_1PR69PLZaqlFZMo5YLUN28iK",
      price: "$0.00",
      features: ["Never Expire", "5 Photos"],
    },
    {
      planName: 1,
      priceId: "price_1Nj1xMLZaqlFZMo5QcT07BYS",
      testId: "price_1NZhA4LZaqlFZMo5xgm73XYL",
      price: "$49.99",
      features: [
        "Never Expire",
        "Unlimited Photos",
        "Video and Music Gallery",
        "Social Media Integration",
        "Custom Background Music",
        "Advanced Privacy Controls",
        "Additional Administrators",
        "Custom Notifications",
      ],
    },
    {
      planName: 2,
      priceId: "price_1SuGJJLZaqlFZMo584MKvBve", // LIVE - Premium Service $44.99 ✅
      testId: "price_1SuKWQLZaqlFZMo5RaE9A9Nn", // TEST - Premium Service $44.99
      framePriceId: "price_1Swri4LZaqlFZMo5RdVVs1Xm", // LIVE - Picture Frame $25 ✅
      price: "$69.99",
      features: [
        "Never Expire",
        "Unlimited Photos",
        "Video and Music Gallery",
        "Social Media Integration",
        "Custom Background Music",
        "Advanced Privacy Controls",
        "Additional Administrators",
        "Custom Notifications",
        "custom picture frame",
      ],
    },
  ];
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
  const { user, delayedTrigger } = useUserContext();
  const [activeButton, setActiveButton] = useState();
  const [message, setMessage] = useState();
  const [loading, setLoading] = useState(false);
  const [showShippingModal, setShowShippingModal] = useState(false);
  const [shippingCountry, setShippingCountry] = useState("US");
  const [shippingState, setShippingState] = useState("");
  const [pendingPremium, setPendingPremium] = useState(null);
  const [shippingError, setShippingError] = useState("");
  const isShippingBlocked =
    shippingCountry !== "US" ||
    (shippingState && EXCLUDED_SHIPPING_STATES.includes(shippingState));
  const canContinueToPayment =
    shippingCountry === "US" &&
    shippingState &&
    !EXCLUDED_SHIPPING_STATES.includes(shippingState);
  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("Order placed! You will receive an email confirmation.");
    }

    if (query.get("canceled")) {
      setMessage(
        "Order canceled -- continue to shop around and checkout when you're ready."
      );
    }
  }, []);
  useEffect(() => {
  console.log("🧪 USER CONTEXT:", user);
}, [user]);

const handleSubmit = async (event, priceId, planName, shippingStateValue = null) => {
  event.preventDefault();
  const userId = user?._id || user?.meta?._id;

  if (!userId) {
    alert("Faltan datos de usuario. Intenta recargar la página.");
    setLoading(false);
    return;
  }
  if (planName === 0) {
    localStorage.setItem("package", planName);
    navigate("/success?purchaseType=FIRST_PLAN_PURCHASE&plan=0");
    setLoading(false);
    return;
  }
  try {
    const body = { userId, priceId };
    if (planName === 2 && shippingStateValue) {
      body.shippingState = shippingStateValue;
    }
    const response = await axios.post(
      `${backendUrl}/api/create-checkout-session`,
      body
    );
    if (response.data.url) {
      localStorage.setItem("package", planName);
      window.location.href = response.data.url;
    }
  } catch (error) {
    console.error("❌ Error al crear sesión de Stripe:", error);
    const msg =
      error.response?.data?.error ||
      error.message ||
      "No se pudo iniciar el pago. Intenta de nuevo.";
    setShippingError(msg);
  } finally {
    setLoading(false);
  }
};

const openShippingModal = (plan) => {
  setPendingPremium(plan);
  setShippingCountry("US");
  setShippingState("");
  setShippingError("");
  setShowShippingModal(true);
};

const handleContinueToPayment = (e) => {
  if (!pendingPremium || !canContinueToPayment) return;
  setShippingError("");
  const priceId =
    process.env.REACT_APP_BACKEND_URL === "http://localhost:5000"
      ? pendingPremium.testId
      : pendingPremium.priceId;
  setLoading(true);
  delayedTrigger(() => {
    handleSubmit(e, priceId, pendingPremium.planName, shippingState);
  });
};



  return (
    <div className="memoLogin-page">
      <div className="memoLogin-pricing1">
        <div className="pricing-text">
          <p>One Price, Endless Memories</p>
          <p>For Your</p>
          <p className="pfont">loved ones</p>
          {/* <img src={arrow} /> */}
        </div>
        <div className="grid-cards">
          {Plans.map((plan, planIndex) => (
            <div className="memopricing-card1" key={planIndex}>
              {plan.planName === 0 && (
                  <p className="life">Free Plan</p>
                )}
              {plan.planName === 1 && (
                  <p className="life">Standard Plan</p>
                )}
                {plan.planName === 2 && (
                  <p className="life">Premium Plan</p>
                )}
              {/*<p className="life">Lifetime</p>*/}
              {/* <h2>$49.99</h2> */}
              <h2>{plan.price}</h2>
              <p className="flexible">Most flexible</p>

              <p className="divider"></p>

              <div className="memoLinesDiv">
                {plan?.features?.map((feature, featureIndex) => (
                  <p className="memoline" key={featureIndex}>
                    <img src={tick} alt="tick icon" /> <span>{feature}</span>
                  </p>
                ))}
                {plan.planName === 2 && (
                  <p className="memoline shipping-disclaimer" style={{ fontSize: "12px", color: "rgba(255,255,255,0.9)", marginTop: "8px", fontStyle: "italic" }}>
                    Made in the USA <img src={usFlag} alt="USA" style={{ height: "1em", width: "auto", verticalAlign: "middle", display: "inline-block" }} />
                    <br />
                    Shipping within USA only (excluding HI and AK).
                  </p>
                )}
                <p>{message}</p>
                <button
                  className="memoget-started"
                  onClick={(e) => {
                    setActiveButton(planIndex);
                    if (plan.planName === 2) {
                      openShippingModal(plan);
                      return;
                    }
                    setLoading(true);
                    delayedTrigger(() => {
                      const priceId =
                        process.env.REACT_APP_BACKEND_URL === "http://localhost:5000"
                          ? plan.testId
                          : plan.priceId;
                      handleSubmit(e, priceId, plan.planName);
                    });
                  }}
                >
                  {activeButton === planIndex ? (
                    <ThreeDots
                      height="50"
                      width="50"
                      radius="9"
                      color="#fff"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  ) : (
                    "Get started"
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="pfbottom1"></div>

      {showShippingModal && (
        <div
          className="shipping-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => !loading && setShowShippingModal(false)}
        >
          <div
            className="shipping-modal"
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "24px",
              maxWidth: "420px",
              width: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: "0 0 12px 0", color: "#5c5470", fontSize: "1.25rem" }}>
              Confirm shipping destination
            </h3>
            <p style={{ margin: "0 0 16px 0", color: "#555", fontSize: "14px" }}>
              Made in the USA <img src={usFlag} alt="USA" style={{ height: "1em", width: "auto", verticalAlign: "middle", display: "inline-block" }} />
                    <br />
                    Shipping within USA only (excluding HI and AK). Please confirm your shipping location.
            </p>

            <label htmlFor="shipping-country" style={{ display: "block", marginBottom: "4px", fontWeight: 600, fontSize: "14px" }}>
              Country
            </label>
            <select
              id="shipping-country"
              value={shippingCountry}
              onChange={(e) => {
                setShippingCountry(e.target.value);
                setShippingState("");
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                marginBottom: "12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            >
              <option value="US">United States</option>
              <option value="other">Other (frame not available)</option>
            </select>

            {shippingCountry === "US" && (
              <>
                <label htmlFor="shipping-state" style={{ display: "block", marginBottom: "4px", fontWeight: 600, fontSize: "14px" }}>
                  State
                </label>
                <select
                  id="shipping-state"
                  value={shippingState}
                  onChange={(e) => setShippingState(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    marginBottom: "12px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                >
                  <option value="">Select state</option>
                  {US_STATES.map((s) => (
                    <option key={s.code} value={s.code}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </>
            )}

            {isShippingBlocked && (
              <p
                style={{
                  margin: "0 0 12px 0",
                  padding: "10px",
                  background: "#f8d7da",
                  color: "#721c24",
                  borderRadius: "8px",
                  fontSize: "13px",
                  lineHeight: "1.5",
                }}
              >
                Made in the USA <img src={usFlag} alt="USA" style={{ height: "1em", width: "auto", verticalAlign: "middle", display: "inline-block" }} />
                    <br />
                    Shipping within USA only (excluding HI and AK).
              </p>
            )}

            {shippingError && (
              <p style={{ margin: "0 0 12px 0", color: "#c00", fontSize: "13px" }}>
                {shippingError}
              </p>
            )}

            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "16px" }}>
              <button
                type="button"
                onClick={() => {
                  setShowShippingModal(false);
                  setPendingPremium(null);
                  setShippingError("");
                }}
                disabled={loading}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  border: "1px solid #5c5470",
                  background: "#fff",
                  color: "#5c5470",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleContinueToPayment}
                disabled={!canContinueToPayment || loading}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  border: "none",
                  background: canContinueToPayment && !loading ? "#5c5470" : "#ccc",
                  color: "#fff",
                  cursor: canContinueToPayment && !loading ? "pointer" : "not-allowed",
                }}
              >
                {loading ? (
                  <ThreeDots height="24" width="40" radius="4" color="#fff" ariaLabel="loading" visible />
                ) : (
                  "Continue to payment"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Plan;
